import React from 'react';
import { motion } from 'framer-motion';
import { Anchor } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="bg-navy text-white py-24 px-6 relative overflow-hidden" data-id="element-171">
      {/* Decorative anchors */}
      <Anchor className="absolute top-10 left-10 w-32 h-32 text-white/5 -rotate-12" data-id="element-172" />
      <Anchor className="absolute bottom-10 right-10 w-48 h-48 text-white/5 rotate-12" data-id="element-173" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-teal/20 text-teal-300 mb-8 border border-teal/30" data-id="element-175">
          <Anchor className="w-10 h-10" data-id="element-176" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-5xl font-serif font-bold mb-8 text-white" data-id="element-177">
          El "Ancla de Calma"
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-178">
          <p data-id="element-179">
            A diferencia de las terapias tradicionales de larga duración, este
            es un método de{' '}
            <strong className="text-copper font-semibold" data-id="element-180">
              intervención propioceptiva inmediata
            </strong>
            .
          </p>
          <p data-id="element-181">
            Utilizamos la presión profunda dirigida para enviar una señal
            química directa al cerebro de tu hijo, liberando serotonina y
            dopamina de forma natural.
          </p>
          <p className="text-white font-medium bg-white/5 p-6 rounded-xl border border-white/10 mt-8" data-id="element-182">
            Es el interruptor biológico que apaga el incendio sensorial desde
            adentro hacia afuera, sin necesidad de que él diga una sola palabra.
          </p>
        </motion.div>
      </div>
    </section>;
}